import { defaultPastShiftTab, pastShiftTabs } from '../../../../ui/features/mission-details/types';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
export const usePastShiftsTab = () => {
    var _a;
    const [searchParams, setSearchParams] = useSearchParams();
    const pastShiftTabFromParams = searchParams.get('pastShiftsTab');
    const pastShiftTab = (_a = pastShiftTabs.find((item) => item === pastShiftTabFromParams)) !== null && _a !== void 0 ? _a : defaultPastShiftTab;
    const setPastShiftTab = React.useCallback((value) => {
        setSearchParams((prevValues) => {
            if (!value && prevValues.has('pastShiftsTab')) {
                prevValues.delete('pastShiftsTab');
                return prevValues;
            }
            prevValues.set('pastShiftsTab', value);
            return prevValues;
        }, { replace: true });
    }, [setSearchParams]);
    return {
        pastShiftTab,
        setPastShiftTab,
    };
};
